import { CountryDropdownItem, DropdownButton } from "@similarweb/ui-components";
import ContactUsItemWrap from "app/components/ContactUs/ContactUsItemWrap";
import ContactUsLink from "app/components/ContactUs/ContactUsLink";
import I18n, { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import type * as React from "react";
import { allTrackers } from "app/services/track/track";
import { DropdownContainer } from "./DropdownContainer";

import type { JSX } from "react";

interface DashboardWizardCountryProps {
    availableCountries: any[];
    changeCountry: (itemId: number) => void;
    selectedCountryId: number;
    titleComponent?: JSX.Element;
    disabled?: boolean;
    isHidden?: boolean;
}

interface CountryDropdownItemData {
    id: number;
    key: number;
    text?: string;
    [prop: string]: FixmeType;
}

const DashboardWizardCountry: React.FC<DashboardWizardCountryProps> = ({
    availableCountries,
    changeCountry,
    selectedCountryId,
    titleComponent,
    disabled = false,
    isHidden = false,
}) => {
    const t = useTranslation();
    const countriesItems: CountryDropdownItemData[] = [];
    availableCountries?.forEach((country: any, index) => {
        const { id: countyId } = country;
        const countyIdAsNumber = Number(countyId);
        countriesItems.push({
            ...country,
            id: isNaN(countyIdAsNumber) ? countyId : countyIdAsNumber,
            key: index,
        });
    });
    const contactFormIsVisible = availableCountries.length === 1;
    const contents = [
        <DropdownButton
            disabled={disabled}
            key="country-dropdown-header"
        >
            <I18n>home.dashboards.wizard.country.dropdown</I18n>
        </DropdownButton>,
        ...countriesItems,
    ];
    const onSelect = (item: CountryDropdownItemData) => {
        allTrackers.trackEvent("Drop Down", "click", `Country/${item.text}`);
        changeCountry(item.id);
    };

    if (isHidden) {
        return null;
    }

    if (contactFormIsVisible) {
        contents.push(
            <div
                key="last-item"
                id="lastitem"
                className="DropdownItem u-flex-row"
            >
                <ContactUsLink
                    label="Country"
                    className="dropdown-item-contact-us-link"
                    onClick={(e) => e?.stopPropagation()}
                >
                    <I18n>demo.dropdown.message</I18n>
                </ContactUsLink>
            </div>,
        );
    }
    return (
        <div className="country">
            {titleComponent}
            <DropdownContainer
                disabled={disabled}
                initialSelection={{ [selectedCountryId]: true }}
                hasSearch={!contactFormIsVisible}
                itemsComponent={CountryDropdownItem}
                onSelect={onSelect}
                dropdownPopupHeight={150}
                showCountryFlag={true}
                itemWrapper={ContactUsItemWrap}
                noResultsMessage={t("dropdown.no.results")}
            >
                {contents}
            </DropdownContainer>
        </div>
    );
};

export default DashboardWizardCountry;
